module.exports = __webpack_public_path__ + "static/img/img_program_c.7ec37afe.png";